import React from 'react';
import {useParams} from 'react-router-dom';
import {useTranslation} from '../../../hook/useTranslation';
import './Entity.scss';
import Button from '../../button/Button';
import Contact from '../../contact/Contact';

export default function LayoutEntity() {
    const {translationPath} = useParams<'translationPath'>();
    const i18n = useTranslation();

    return (
        <div className="career-model__entity">
            <div className="career-model__entity--content">
                <div className="career-model__entity--header">
                    <Button text="Back"
                            uri={i18n.translate(`show.back_link`) + i18n.translate(`show.items.${translationPath}.links.back_link`)}
                            additionalClass="icon-only icon-back"/>
                </div>
                <h1 className="career-model__entity--title">{i18n.translate(`show.items.${translationPath}.title`)}</h1>
                {i18n.translate(`show.items.${translationPath}.subtitle`) &&
                    <h2 className="career-model__entity--sub-title">{i18n.translate(`show.items.${translationPath}.subtitle`)}</h2>
                }
                <p className="career-model__entity--desc"
                   dangerouslySetInnerHTML={{__html: i18n.translate(`show.items.${translationPath}.description`)}}></p>
                {i18n.translate(`show.items.${translationPath}.items_title`) &&
                    <h2 className="career-model__entity--items-title">{i18n.translate(`show.items.${translationPath}.items_title`)}</h2>
                }
                <div className="career-model__entity--links" style={{display:'none'}}>
                    {i18n.keyExists(`show.items.${translationPath}.items.0.quote_text`) &&
                        <div className="career-model__entity--link-1">
                            <div className="career-model__entity--image-1">
                                <img src={i18n.translate(`show.items.${translationPath}.items.0.image`)} alt=""/>
                            </div>
                            <p className="career-model__entity--quote-1">
                                {i18n.translate(`show.items.${translationPath}.items.0.quote_text`)}
                            </p>
                            <p className="career-model__entity--author-1">
                                {i18n.translate(`show.items.${translationPath}.items.0.quote_author`)}
                            </p>
                        </div>
                    }
                    {i18n.keyExists(`show.items.${translationPath}.items.1.quote_text`) &&
                        <div className="career-model__entity--link-2">
                            <div className="career-model__entity--image-2">
                                <img src={i18n.translate(`show.items.${translationPath}.items.1.image`)} alt=""/>
                            </div>
                            <p className="career-model__entity--quote-2"
                               dangerouslySetInnerHTML={{__html: i18n.translate(`show.items.${translationPath}.items.1.quote_text`)}}>
                            </p>
                            <p className="career-model__entity--author-2">
                                {i18n.translate(`show.items.${translationPath}.items.1.quote_author`)}
                            </p>
                        </div>
                    }
                    {i18n.keyExists(`show.items.${translationPath}.items.2.quote_text`) &&
                        <div className="career-model__entity--link-3">
                            <div className="career-model__entity--image-3">
                                <img src={i18n.translate(`show.items.${translationPath}.items.2.image`)} alt=""/>
                            </div>
                            <p className="career-model__entity--quote-3">
                                {i18n.translate(`show.items.${translationPath}.items.2.quote_text`)}
                            </p>
                            <p className="career-model__entity--author-3">
                                {i18n.translate(`show.items.${translationPath}.items.2.quote_author`)}
                            </p>
                        </div>
                    }
                </div>
            </div>
            {
                i18n.keyExists(`show.items.${translationPath}.override.contact.person.name`) ? (
                    <Contact title={i18n.translate(`show.items.${translationPath}.override.contact.title`)}
                             person={{
                                 email: i18n.translate(`show.items.${translationPath}.override.contact.person.email`),
                                 emailLabel: i18n.translate(`show.items.${translationPath}.override.contact.person.email-label`),
                                 image: i18n.translate(`show.items.${translationPath}.override.contact.person.image`),
                                 name: i18n.translate(`show.items.${translationPath}.override.contact.person.name`),
                                 phone: i18n.translate(`show.items.${translationPath}.override.contact.person.phone`),
                                 title: i18n.translate(`show.items.${translationPath}.override.contact.person.title`)
                             }}/>
                ) : (
                    i18n.keyExists(`show.items.${translationPath}.override.contact.text`) ? (
                        <Contact title={i18n.translate(`show.items.${translationPath}.override.contact.title`)}
                                 text={i18n.translate(`show.items.${translationPath}.override.contact.text`)}/>
                    ) : (
                        <Contact title={i18n.translate('show.contact.title')}
                                 person={{
                                     email: i18n.translate('show.contact.person.email'),
                                     emailLabel: i18n.translate(`show.contact.person.email-label`),
                                     image: i18n.translate('show.contact.person.image'),
                                     name: i18n.translate('show.contact.person.name'),
                                     phone: i18n.translate('show.contact.person.phone'),
                                     title: i18n.translate('show.contact.person.title')
                                 }}/>
                    )
                )}
        </div>
    );
};
